module.exports = __webpack_public_path__ + "img/0Q3A2940_L_Foamcore_MockedUp.6b8f55aa.jpg";